export default {"src":"/_next/static/media/repl-it.d0662e6b.svg","height":37,"width":101};